import type { App } from 'vue'
import type { Store } from 'vuex'

// Date picker calendars start on the org's week start (Organization.week_starts_on, 1-7 => Su-Sa).
// PrimeVue's locale.firstDayOfWeek and vue-datepicker's weekStart both number days 0-6 => Su-Sa.
export function calendarFirstDayOfWeek (weekStartsOn: number): number {
  return weekStartsOn - 1
}

// PrimeVue's config is reactive, so DatePickers re-render when the org setting changes.
export function syncPrimeVueFirstDayOfWeek (app: App, store: Store<unknown>) {
  store.watch(
    (_state, getters) => getters.weekStartsOn,
    (weekStartsOn: number) => {
      app.config.globalProperties.$primevue.config.locale!.firstDayOfWeek = calendarFirstDayOfWeek(weekStartsOn)
    },
    { immediate: true }
  )
}
